import { Injectable } from '@angular/core';
import { ReportsService as ApiReportsService } from '@ducat-pro-anapi/swag-anapi-v2';

import { createApi, PartyIdExtension } from '../utils';

@Injectable({
    providedIn: 'root',
})
export class ReportsService extends createApi(ApiReportsService, [PartyIdExtension]) {}
